export const Marquee = ({ items, className = "" }) => {
  const row = items.map((i) => i.toUpperCase()).join("   ///   ");
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y border-black/10 bg-[#F5F5F2] py-4 select-none ${className}`}
    >
      <div className="flex w-max whitespace-nowrap animate-marquee">
        {[0, 1].map((i) => (
          <span
            key={i}
            aria-hidden={i === 1}
            className="px-6 font-mono text-xs uppercase tracking-[0.35em] text-slate-500"
          >
            {row}   ///
          </span>
        ))}
      </div>
    </div>
  );
};
